'use client';
import { useState, useEffect } from 'react';
import {size} from '../size';


export const useResizeHook = () => {
    const [windowWidth, setWindowWidth] = useState(0); // Initialize with a default value

    useEffect(() => {
        // Update state only on the client side
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Set initial width and add event listener
        handleResize();
        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const mobileL425 = Number(size.mobileL.slice(0, -2));
    const tailwindSm640 = Number(size.tailwindSm.slice(0, -2));
    const tailwindMd768 = Number(size.tailwindMd.slice(0, -2));
    const tailwindLg1024 = Number(size.tailwindLg.slice(0, -2));
    const tailwindXl1280 = Number(size.tailwindXl.slice(0, -2));
    const laptopL1440 = Number(size.laptopL.slice(0, -2));

    const lessThanMobile425 = windowWidth < mobileL425;
    const betweenTailwindMd768tailwindLg1024 = windowWidth >= tailwindMd768 && windowWidth < tailwindLg1024;
    const greaterThanLaptopL1440 = windowWidth >= laptopL1440;
    const greaterThanTailwindXl1024 = windowWidth >= tailwindXl1280;
    const greaterThanTailwindLg1024 = windowWidth >= tailwindLg1024;
    const greaterThanTailwindMd768 = windowWidth >= tailwindMd768;
    const greaterThanTailwindSm640 = windowWidth >= tailwindSm640;

    return {
        windowWidth,
        lessThanMobile425,
        betweenTailwindMd768tailwindLg1024,
        greaterThanLaptopL1440,
        greaterThanTailwindXl1024,
        greaterThanTailwindLg1024,
        greaterThanTailwindMd768,
        greaterThanTailwindSm640,
    };
};
